@if (ZendeskTicket) {
  <div class="container-fluid">
    <div class="row row-padding centered">
      <div class="col">
        <label class="title-label">{{
          ZendeskTicket.ZendeskTicketContent.subject
        }}</label>
      </div>
    </div>
    <div class="row row-padding">
      <div class="col">
        <app-display-card>
          <div class="row">
            <div class="col">
              <label class="section-label">Ticket Information</label>
            </div>
          </div>
          <div class="row row-padding">
            <div class="col">
              <div class="inner-panel rounded">
                <div class="row row-padding">
                  <div class="col-4">
                    <div class="row">
                      <div class="col">
                        <label>Ticket #:</label>
                      </div>
                      <div class="col">
                        <label class="unbold">{{
                          ZendeskTicket.ZendeskTicketContent.id
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="row">
                      <div class="col">
                        <label>Status:</label>
                      </div>
                      <div class="col">
                        <label class="unbold">{{ ZendeskTicket.status }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="row">
                      <div class="col">
                        <label>Priority:</label>
                      </div>
                      <div class="col">
                        <label class="unbold">{{
                          ZendeskTicket.ZendeskTicketContent.priority
                        }}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row row-padding">
                  <div class="col-4">
                    <div class="row">
                      <div class="col">
                        <label>Submitted At:</label>
                      </div>
                      <div class="col">
                        <label class="unbold">{{
                          ZendeskTicket.ZendeskTicketContent.created_at
                            | date: 'MM/dd/y'
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="row">
                      <div class="col">
                        <label>Requester:</label>
                      </div>
                      <div class="col">
                        <label class="unbold">{{
                          getZendeskUserName(
                            ZendeskTicket.ZendeskTicketContent.requester_id
                          )
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="row">
                      <div class="col">
                        <label>CCs:</label>
                      </div>
                      <div class="col">
                        <label class="line-break unbold">{{
                          getCCEmails(
                            ZendeskTicket.ZendeskTicketContent.collaborator_ids
                          )
                        }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (
            ZendeskTicket.ZendeskTicketContent.fields.length > 0 &&
            ZendeskTicketFields.length > 0
          ) {
            <div class="row row-padding">
              <div class="col">
                <div class="inner-panel rounded">
                  @for (
                    FieldArray of generateTicketFieldsMultidimensionalArray(
                      ZendeskTicket.ZendeskTicketContent.fields
                    );
                    track rowIndex;
                    let rowIndex = $index
                  ) {
                    <div class="row row-padding">
                      @for (Field of FieldArray; track Field) {
                        <div class="col-6">
                          <div class="row">
                            <div class="col">
                              <label
                                >{{
                                  ZendeskTicketFieldsMappedByZendeskTicketFieldId[
                                    Field.id
                                  ].title
                                }}:</label
                              >
                            </div>
                            <div class="col">
                              <label class="text-break unbold">{{
                                Field.value
                              }}</label>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </app-display-card>
      </div>
    </div>
    <div class="row row-padding">
      <div class="col">
        <app-display-card>
          <div class="row">
            <div class="col">
              <label class="section-label">{{
                viewOnly ? 'Comments' : 'Send Response to VIVE'
              }}</label>
            </div>
          </div>
          @for (
            ZendeskTicketComment of ZendeskTicketComments;
            track ZendeskTicketComment
          ) {
            <div class="row row-padding">
              <div class="col">
                <div class="inner-panel rounded minvh-10">
                  <div class="row row-padding-bottom-lg">
                    <div class="col-auto">
                      <label>{{
                        getZendeskUserName(
                          ZendeskTicketComment.ZendeskTicketCommentContent
                            .author_id!
                        )
                      }}</label>
                    </div>
                    <div class="col-auto">
                      <label class="unbold">{{
                        formatDate(
                          ZendeskTicketComment.ZendeskTicketCommentContent
                            .created_at
                        )
                      }}</label>
                    </div>
                  </div>
                  <div class="row row-padding-bottom">
                    <div class="col">
                      <p>{{ ZendeskTicketComment.commentText }}</p>
                    </div>
                  </div>
                  <div class="row">
                    @for (
                      ZendeskTicketAttachment of ZendeskTicketComment.ZendeskTicketAttachments;
                      track ZendeskTicketAttachment
                    ) {
                      <div class="col-auto">
                        <div class="col attachment-bubble">
                          <a
                            href="javascript:void(0)"
                            (click)="
                              downloadAttachment(ZendeskTicketAttachment)
                            "
                            >{{ ZendeskTicketAttachment.fileName }}</a
                          >
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          @if (
            !['Closed', 'Solved'].includes(ZendeskTicket.status || '') &&
            !viewOnly
          ) {
            <div
              class="row row-padding minvh-25"
              [formGroup]="ZendeskTicketCommentContentFormGroup"
            >
              <div class="col">
                <div class="inner-panel h-100 rounded p-0">
                  <div class="col h-100 d-flex flex-column position-relative">
                    <div class="row flex-grow-1">
                      <div class="col">
                        <textarea
                          type="text"
                          class="form-control h-100 comment-input"
                          placeholder="Write a response..."
                          formControlName="body"
                        ></textarea>
                        <input
                          #fileUploadInput
                          type="file"
                          (change)="selectedFile($event)"
                          multiple
                          hidden
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="row attachment-bubble-row ms-0">
                          @for (
                            Attachment of ZendeskTicketCommentContentFormGroup
                              .controls['Attachments'].value;
                            track Attachment;
                            let i = $index
                          ) {
                            <div class="col-md-6 col-lg-3 my-2">
                              <div
                                class="row uploaded-attachment-bubble g-0 align-items-center"
                              >
                                <div class="col-10 overflow-hidden text-nowrap">
                                  <label class="m-0">{{
                                    Attachment.filename
                                  }}</label>
                                </div>
                                <div class="offset-md-1 col-2 col-md-1">
                                  <i
                                    class="remove-attachment-icon bi bi-x-lg"
                                    (click)="removeCommentAttachment(i)"
                                  ></i>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div
                        class="col-auto d-flex align-items-end justify-content-end"
                      >
                        <i
                          class="upload-icon me-2 bi bi-file-earmark-arrow-up"
                          (click)="uploadFile()"
                        ></i>
                        <i
                          class="send-icon me-2 bi bi-send-fill"
                          (click)="saveComment()"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </app-display-card>
      </div>
    </div>
  </div>
}
